<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">Automations</h5>
          </div>
          <div class="card-body">
            <el-button
              type="primary"
              size="medium"
              style="float: right"
              class="mb-4"
              @click="() => (showModal = true)"
              >Add Automation</el-button
            >
            <!-- TABLE -->
            <table
              id="tableData"
              class="table table-striped"
              style="text-align:center"
              v-if="tableDataLoaded"
            >
              <tr>
                <th></th>
                <th>
                  Edit
                </th>
                <th>
                  Name
                </th>
                <th>
                  Conditions
                </th>
                <th>
                  Result
                </th>
              </tr>
              <tr v-for="(data, index) in tableData" v-bind:key="index">
                <td>
                  <el-switch
                    active-color="#13ce66"
                    inactive-color="#ad466c"
                    v-model="tableData[index].enabled"
                    @change="changeStatus(data, index)"
                    class="onoffswitch"
                  ></el-switch>
                </td>
                <td>
                  <el-dropdown
                    class="inlineButton"
                    trigger="click"
                    @command="handleCommand"
                  >
                    <!-- size="mini"
                      icon="el-icon-arrow-down" -->
                    <!-- <el-button type="primary"> </el-button> -->
                    <el-button type="primary">
                      <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="el-icon-edit"
                        :command="{ action: 'edit', data: data, index: index }"
                        >Edit</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-delete"
                        divided
                        :command="{
                          action: 'delete',
                          data: data,
                          index: index
                        }"
                        >Delete</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </td>
                <td>
                  {{ data.name }}
                </td>
                <td style="white-space:pre-wrap; word-wrap:break-word">
                  {{ automatedConditions(index) }}
                </td>
                <td style="white-space:pre-wrap; word-wrap:break-word">
                  {{ automatedResults(index) }}
                </td>
              </tr>
            </table>
          </div>
          <!-- Delete Automation Modal -->
          <el-dialog
            title="Confirm"
            :visible.sync="showConfirmation"
            width="30%"
            custom-class="confirmModal"
          >
            <span>Are you sure you want to delete this automation?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showConfirmation = false">Cancel</el-button>
              <el-button type="primary" @click="confirmDeleteAutomation"
                >Confirm</el-button
              >
            </span>
          </el-dialog>
          <!-- /Delete Automation Modal -->
          <!-- ADD AUTOMATION MODAL -->

          <el-dialog
            :visible.sync="showModal"
            @closed="clearAutomation"
            class="custom-el-modal"
          >
            <h6 slot="title">
              {{ editModal ? 'Edit Automation' : 'Add Automation' }}
            </h6>
            <span class="form-group">
              <el-form label-position="left" class="validationError">
                <el-form-item label="Automation Name:">
                  <el-input
                    type="text"
                    id="name"
                    name="name"
                    style="width:50%"
                    maxlength="25"
                    show-word-limit
                    v-model="selectedAutomation.name"
                    class="el-dark-input"
                  />
                </el-form-item>
              </el-form>
              <div
                v-for="(condition, index) in selectedAutomation.conditions[0]
                  .groupedConditions"
                v-bind:key="`conditions-${index}`"
                class="text-center"
              >
                <el-form :inline="true">
                  <el-form-item label="IF">
                    <el-select
                      class="el-dark-input"
                      v-model="
                        selectedAutomation.conditions[0].groupedConditions[
                          index
                        ].variable
                      "
                    >
                      <el-option
                        v-for="item in variableOptions"
                        :key="`${item.value}-${index}`"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option
                    ></el-select>
                  </el-form-item>
                  <el-form-item label="IS">
                    <el-select
                      class="el-dark-input"
                      v-model="
                        selectedAutomation.conditions[0].groupedConditions[
                          index
                        ].equalityOperator
                      "
                    >
                      <div
                        v-if="
                          selectedAutomation.conditions[0].groupedConditions[
                            index
                          ].variable !== 'Number of Time Spans'
                        "
                      >
                        <el-option
                          v-for="item in equalityOperatorOptions"
                          :key="`${item.value}-${index}`"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </div>
                      <div v-else>
                        <el-option
                          v-for="item in equalityOperatorOptions2"
                          :key="`${item.value}-${index}`"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option></div
                    ></el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      class="el-dark-input"
                      v-model="
                        selectedAutomation.conditions[0].groupedConditions[
                          index
                        ].value
                      "
                      value-key="id"
                      v-if="
                        selectedAutomation.conditions[0].groupedConditions[
                          index
                        ].variable !== 'Number of Time Spans'
                      "
                    >
                      <div
                        v-if="
                          selectedAutomation.conditions[0].groupedConditions[
                            index
                          ].variable === 'Employee Name'
                        "
                      >
                        <el-option
                          v-for="item in valueOptionsEmployees"
                          :key="`${item.value.id}-${index}`"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </div>
                      <div
                        v-if="
                          selectedAutomation.conditions[0].groupedConditions[
                            index
                          ].variable === 'Employee Type'
                        "
                      >
                        <el-option
                          v-for="item in valueOptionsTypes"
                          :key="`${item.value.id}-${index}`"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </div>
                      <div
                        v-if="
                          selectedAutomation.conditions[0].groupedConditions[
                            index
                          ].variable === 'Employee Category'
                        "
                      >
                        <el-option
                          v-for="item in valueOptionsCategories"
                          :key="`${item.value.id}-${index}`"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </div>
                    </el-select>
                    <el-input-number
                      class="el-dark-input"
                      v-model="
                        selectedAutomation.conditions[0].groupedConditions[
                          index
                        ].value
                      "
                      v-else
                      style="width:75%"
                      :max="10"
                      :min="0"
                      :step="1"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <el-button
                    size="mini"
                    type="danger"
                    circle
                    icon="el-icon-delete"
                    classs="mt-1 pt-3"
                    v-if="index > 0"
                    @click="
                      () => {
                        selectedAutomation.conditions[0].groupedConditions.splice(
                          index,
                          1
                        );
                      }
                    "
                  ></el-button>
                </el-form>
                <el-button
                  v-if="
                    index ===
                      selectedAutomation.conditions[0].groupedConditions
                        .length -
                        1
                  "
                  type="warning"
                  size="small"
                  style="margin:0 auto; display:block"
                  class="mb-4"
                  @click="
                    () => {
                      selectedAutomation.conditions[0].groupedConditions.push({
                        variable: null,
                        equalityOperator: null,
                        value: null,
                        logicalOperator: null
                      });
                    }
                  "
                  >Add Condition</el-button
                >
                <el-switch
                  active-color="#ad466c"
                  inactive-color="#ad466c"
                  v-else
                  v-model="
                    selectedAutomation.conditions[0].groupedConditions[0]
                      .logicalOperator
                  "
                  style="margin:0 auto; display:block"
                  class="mb-4"
                  active-text="OR"
                  inactive-text="AND"
                  active-value="||"
                  inactive-value="&&"
                ></el-switch>
              </div>
              <div
                v-for="(result, index) in selectedAutomation.results"
                v-bind:key="`results-${index}`"
                class="text-center"
              >
                <el-form :inline="true">
                  <el-form-item label="THEN">
                    <el-select
                      class="el-dark-input"
                      v-model="selectedAutomation.results[index].action"
                      v-if="index === 0"
                      @change="
                        () => {
                          selectedAutomation.results[index].amount = null;
                          selectedAutomation.results[index].content = null;
                          if (selectedAutomation.results.length > 1) {
                            selectedAutomation.results[1].action = null;
                          }
                        }
                      "
                    >
                      <el-option
                        v-for="item in actionOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option
                    ></el-select>
                    <el-select
                      class="el-dark-input"
                      v-model="selectedAutomation.results[index].action"
                      v-if="index === 1"
                    >
                      <div
                        v-if="
                          index === selectedAutomation.results.length - 1 &&
                            selectedAutomation.results[0].action !== 'Add Note'
                        "
                      >
                        <el-option
                          v-for="item in actionOptions2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </div>
                      <div v-else>
                        <el-option
                          v-for="item in actionOptions3"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option></div
                    ></el-select>
                  </el-form-item>
                  <el-form-item
                    label="Amount:"
                    v-if="
                      selectedAutomation.results[index].action === 'Add Time' ||
                        selectedAutomation.results[index].action ===
                          'Remove Time'
                    "
                  >
                    <el-input-number
                      class="el-dark-input"
                      v-model="selectedAutomation.results[index].amount"
                      style="width:75%"
                      :max="24"
                      :min="0"
                      :step="0.25"
                      :precision="2"
                    >
                      <template slot="append">HRS</template></el-input-number
                    >
                  </el-form-item>
                  <el-form-item
                    label="Content:"
                    v-if="
                      selectedAutomation.results[index].action === 'Add Note'
                    "
                  >
                    <el-input
                      class="el-dark-input"
                      v-model="selectedAutomation.results[index].content"
                      style="width:100%"
                      maxlength="400"
                    ></el-input>
                  </el-form-item>
                  <el-button
                    size="mini"
                    type="danger"
                    circle
                    icon="el-icon-delete"
                    classs="mt-1 pt-3"
                    v-if="index > 0"
                    @click="
                      () => {
                        selectedAutomation.results.splice(index, 1);
                      }
                    "
                  ></el-button>
                </el-form>
                <el-button
                  v-if="
                    index === selectedAutomation.results.length - 1 &&
                      selectedAutomation.results.length < 2
                  "
                  type="warning"
                  size="small"
                  style="margin:0 auto; display:block"
                  class="mb-4"
                  @click="
                    () => {
                      selectedAutomation.results.push({
                        action: null,
                        amount: null,
                        content: null
                      });
                    }
                  "
                  >Add Result</el-button
                >
              </div>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showModal = false">Cancel</el-button>
              <el-button v-if="!editModal" type="primary" @click="addAutomation"
                >Confirm</el-button
              >
              <el-button v-else type="primary" @click="editAutomation"
                >Edit</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import { db } from '../assets/js/firebase/db.js';

export default {
  name: 'automation',
  components: {},
  data() {
    return {
      showModal: false,
      tableDataLoaded: false,
      editModal: false,
      selectedAutomation: {
        name: null,
        conditions: [
          {
            groupedConditions: [
              {
                variable: null,
                equalityOperator: null,
                value: null,
                logicalOperator: null
              }
            ]
          }
        ],
        results: [
          {
            action: null,
            amount: null,
            content: null
          }
        ]
      },
      variableOptions: [
        {
          value: 'Employee Name',
          label: 'Employee Name'
        },
        {
          value: 'Employee Type',
          label: 'Employee Type'
        },
        {
          value: 'Employee Category',
          label: 'Employee Category'
        },
        {
          value: 'Number of Time Spans',
          label: 'Number of Time Spans'
        }
      ],
      equalityOperatorOptions: [
        {
          value: '==',
          label: 'Equal To'
        },
        {
          value: '!=',
          label: 'Not Equal To'
        }
      ],
      equalityOperatorOptions2: [
        {
          value: '==',
          label: 'Equal To'
        },
        {
          value: '!=',
          label: 'Not Equal To'
        },
        {
          value: '>',
          label: 'Greater Than'
        },
        {
          value: '<',
          label: 'Less Than'
        },
        {
          value: '<=',
          label: 'Less Than or Equal To'
        },
        {
          value: '>=',
          label: 'Greater Than or Equal To'
        }
      ],
      actionOptions: [
        {
          value: 'Add Time',
          label: 'Add Time'
        },
        {
          value: 'Remove Time',
          label: 'Remove Time'
        },
        {
          value: 'Add Note',
          label: 'Add Note'
        }
      ],
      actionOptions2: [
        {
          value: 'Add Note',
          label: 'Add Note'
        }
      ],
      actionOptions3: [
        {
          value: 'Add Time',
          label: 'Add Time'
        },
        {
          value: 'Remove Time',
          label: 'Remove Time'
        }
      ],

      valueOptionsEmployees: [],
      valueOptionsTypes: [],
      valueOptionsCategories: [],
      tableData: [],
      showConfirmation: false,
      toDelete: null
    };
  },
  methods: {
    //handles the command from the dropdown(either edit or delete)
    handleCommand(data) {
      //if the command is delete, show confirmation modal
      if (data.action === 'delete') {
        this.toDelete = data;
        this.showConfirmation = true;
      } else if (data.action === 'edit') {
        this.editModal = true;
        this.populateModal(data.data);
        this.showModal = true;
      }
    },
    populateModal(data) {
      this.selectedAutomation = JSON.parse(JSON.stringify(data));
    },
    addAutomation() {
      if (this.validateEntry()) {
        try {
          //format the data from the modal before we send to firebase
          let logicalOperator = this.selectedAutomation.conditions[0]
            .groupedConditions[0].logicalOperator;
          if (logicalOperator === null) {
            logicalOperator = '||';
          }
          this.selectedAutomation.name = this.selectedAutomation.name.trim();
          this.selectedAutomation.conditions[0].groupedConditions.forEach(
            condition => {
              condition.logicalOperator = logicalOperator;
            }
          );
          this.selectedAutomation.results.forEach(result => {
            if (result.content) {
              result.content = result.content.trim();
            }
          });
          this.selectedAutomation['enabled'] = true;
          this.selectedAutomation['company'] = this.$store.state.userCompany;
          //send the formatted data to firebase
          db.collection('automations')
            .add(this.selectedAutomation)
            .then(doc => {
              //edit the table to show new data
              this.selectedAutomation['id'] = doc.id;
              this.tableData.push(this.selectedAutomation);
              this.showModal = false;
              this.tableDataLoaded = true;
              this.showSuccess('Automation successfully added');
            });
        } catch (error) {
          console.log(error);
          this.showError('Error adding automation');
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    editAutomation() {
      if (this.validateEntry()) {
        try {
          //format the data from the modal before we send to firebase

          let logicalOperator = this.selectedAutomation.conditions[0]
            .groupedConditions[0].logicalOperator;
          if (logicalOperator === null) {
            logicalOperator = '||';
          }
          this.selectedAutomation.name = this.selectedAutomation.name.trim();
          this.selectedAutomation.conditions[0].groupedConditions.forEach(
            condition => {
              condition.logicalOperator = logicalOperator;
            }
          );
          this.selectedAutomation.results.forEach(result => {
            if (result.content) {
              result.content = result.content.trim();
            }
          });
          this.selectedAutomation['enabled'] = true;
          this.selectedAutomation['company'] = this.$store.state.userCompany;
          //send the formatted data to firebase

          db.collection('automations')
            .doc(this.selectedAutomation.id)
            .update(this.selectedAutomation)
            .then(() => {
              //edit the table to show new data

              let index = this.tableData.findIndex(
                x => x.id === this.selectedAutomation.id
              );

              this.tableData.splice(index, 1, this.selectedAutomation);
              this.showModal = false;
              this.tableDataLoaded = true;
              this.showSuccess('Automation succesfully updated');
            });
        } catch (error) {
          this.showError('Error updating automation');

          console.log(error);
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    clearAutomation() {
      this.editModal = false;
      this.selectedAutomation = {
        name: null,
        conditions: [
          {
            groupedConditions: [
              {
                variable: null,
                equalityOperator: null,
                value: null,
                logicalOperator: null
              }
            ]
          }
        ],
        results: [
          {
            action: null,
            amount: null,
            content: null
          }
        ]
      };
    },
    //change enabled status
    changeStatus: function(data) {
      try {
        db.collection('automations')
          .doc(data.id)
          .update({ enabled: data.enabled });
      } catch (error) {
        this.showError('Error updating automation status');

        console.log(error);
      }
    },
    //format table data conditions into a more readable string
    automatedConditions: function(index) {
      let printedConditions = [];
      let returnString = '';
      let length =
        this.tableData[index].conditions[0].groupedConditions.length - 1;
      this.tableData[index].conditions[0].groupedConditions.forEach(
        (condition, index) => {
          if (index < length) {
            if (condition.variable === 'Number of Time Spans') {
              printedConditions.push(
                `${condition.variable} ${this.getEqualityOperator(condition)} ${
                  condition.value
                } ${
                  condition.logicalOperator === '&&' ? '\n AND \n ' : '\n OR \n'
                }`
              );
            } else {
              printedConditions.push(
                `${condition.variable} ${this.getEqualityOperator(condition)} ${
                  condition.value.name
                } ${
                  condition.logicalOperator === '&&' ? '\n AND \n ' : '\n OR \n'
                }`
              );
            }
          } else {
            if (condition.variable === 'Number of Time Spans') {
              printedConditions.push(
                `${condition.variable} ${this.getEqualityOperator(condition)} ${
                  condition.value
                }`
              );
            } else {
              printedConditions.push(
                `${condition.variable} ${this.getEqualityOperator(condition)} ${
                  condition.value.name
                }`
              );
            }
          }
        }
      );
      printedConditions.forEach(condition => {
        returnString += condition + ' ';
      });
      return `If ${returnString}`;
    },
    //format table data results into a more readable string
    automatedResults: function(index) {
      let printedResults = [];
      let returnString = '';
      let length = this.tableData[index].results.length - 1;
      this.tableData[index].results.forEach((result, index) => {
        if (index < length) {
          printedResults.push(
            `${result.action}: ${
              result.amount !== null
                ? `${result.amount} hrs`
                : `'${result.content}'`
            }\n`
          );
        } else {
          printedResults.push(
            `${result.action}: ${
              result.amount !== null
                ? `${result.amount} hrs`
                : `'${result.content}'`
            }`
          );
        }
      });
      printedResults.forEach(result => {
        returnString += result + ' ';
      });

      return returnString;
    },
    //validate modal entry
    //TODO: highlight where validation errors are in the modal
    validateEntry() {
      let allEntriesValid = true;
      if (
        this.selectedAutomation.name === null ||
        this.selectedAutomation.name.trim() === ''
      ) {
        allEntriesValid = false;
      }
      this.selectedAutomation.conditions[0].groupedConditions.forEach(
        condition => {
          if (condition.equalityOperator === null) {
            allEntriesValid = false;
          } else if (condition.value === null) {
            allEntriesValid = false;
          } else if (condition.variable === null) {
            allEntriesValid = false;
          }
        }
      );
      this.selectedAutomation.results.forEach(result => {
        if (result.action === null) {
          allEntriesValid = false;
        } else if (result.action === 'Add Note') {
          if (result.content === null || result.content.trim() === '') {
            allEntriesValid = false;
          }
        }
      });
      return allEntriesValid;
    },
    //formats the equality operator into a string for the conditions in the table
    getEqualityOperator(condition) {
      if (condition.equalityOperator === '==') {
        return 'is';
      } else if (condition.equalityOperator === '!=') {
        return 'is not';
      } else if (condition.equalityOperator === '<') {
        return 'is less than';
      } else if (condition.equalityOperator === '>') {
        return 'is more than';
      } else if (condition.equalityOperator === '<=') {
        return 'is less than or equal to';
      } else if (condition.equalityOperator === '>=') {
        return 'is more than or equal to';
      }
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    getUsers: function() {
      db.collection('users')
        .where('company', '==', this.$store.state.userCompany)
        .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.valueOptionsEmployees.push({
              value: { id: doc.id, name: doc.data().name },
              label: doc.data().name
            });
          });
        })
        .catch(err => {
          console.log(`Error getting users: ${err}`);
          this.showError('Error getting users');
        });
    },
    getUserTypes: function() {
      db.collection('userTypes')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.valueOptionsTypes.push({
              value: { id: doc.id, name: doc.data().name },
              label: doc.data().name
            });
          });
        })
        .catch(err => {
          console.log(`Error getting user types: ${err}`);
          this.showError('Error getting user types');
        });
    },
    getUserCategories: function() {
      db.collection('employeeCategories')
        .where('org', '==', this.$store.state.userCompany)
        .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.valueOptionsCategories.push({
              value: { id: doc.id, name: doc.data().name },
              label: doc.data().name
            });
          });
        })
        .catch(err => {
          console.log(`Error getting employee categories: ${err}`);
          this.showError('Error getting employee categories');
        });
    },
    getAutomations: function() {
      db.collection('automations')
        .where('company', '==', this.$store.state.userCompany)
        // .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let index = this.tableData.push(doc.data());
            this.tableData[index - 1]['id'] = doc.id;
            this.tableDataLoaded = true;
          });
        })
        .catch(err => {
          console.log(`Error getting automations: ${err}`);
          this.showError('Error getting automations');
        });
    },
    confirmDeleteAutomation() {
      try {
        db.collection('automations')
          .doc(this.toDelete.data.id)
          .delete()
          .then(() => {
            this.tableData.splice(this.toDelete.index, 1);
            this.showConfirmation = false;
            this.toDelete = null;
            this.showSuccess('Automation successfully deleted');
          });
      } catch (error) {
        console.log(error);
        this.showError('Error deleting automation');
        this.toDelete = null;
      }
    }
  },
  //   computed: {
  //   },
  mounted() {
    this.getUsers();
    this.getUserCategories();
    this.getUserTypes();
    this.getAutomations();
  }
};
</script>
<style>
/* TODO: improve visuals of modal */
.el-dialog__header {
  background-color: #ad466c;
}
.el-dialog__body {
  background-color: #353f53;
}
.el-dialog__footer {
  background-color: #353f53;
}
.el-form-item__label {
  color: white !important;
}
/* .el-switch__core.is-checked {
  background-color: #ad466c !important;
  border-color: #ad466c !important;
} */
.el-switch__label {
  /* color: white !important; */
  color: #ad466c !important;

  /* font-size: 30px !important; */
  position: relative;
  /* width: 10%; */
  display: inline-block;
  vertical-align: middle;
}
.el-switch__label.is-active {
  color: #ad466c !important;
  /* -webkit-text-stroke-width: 0.4px;
  -webkit-text-stroke-color: white; */
}
.onoffswitch {
  /* background-color: #ad466c !important; */
  color: #ad466c !important;
  position: relative;
  /* width: 25%; */
  display: inline-block;
  /* vertical-align: middle; */
}
.validationError {
  border-color: red;
  border-width: thick;
}
</style>
